import { isBlank, match } from './strings';

// eslint-disable-next-line import/prefer-default-export
export function filtrarPorTexto(array, valor, { campo = null } = {}) {
  if (!array) {
    return array;
  }

  if (isBlank(valor)) {
    return [...array];
  }

  if (campo) {
    return array.filter((data) => match(data[campo], valor));
  }

  return array.filter((data) => match(data, valor));
}
